import React from "react";

const BreadcrumbSchema = () => {
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://aeronauts.vercel.app/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://aeronauts.vercel.app/about"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Projects",
        "item": "https://aeronauts.vercel.app/projects"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Events",
        "item": "https://aeronauts.vercel.app/events"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Team",
        "item": "https://aeronauts.vercel.app/team"
      },
      {
        "@type": "ListItem",
        "position": 6,
        "name": "Contact",
        "item": "https://aeronauts.vercel.app/contact"
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
    />
  );
};

export default BreadcrumbSchema;
